import React from 'react'
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'

import useStyles from './styles'

const ParticipantsTable = ({
  platformRows,
  externalRecipients,
  onRemovePlatformUser,
  onRemoveExternal,
  disabled,
}) => {
  const classes = useStyles()
  const totalParticipants = platformRows.length + externalRecipients.length

  if (totalParticipants === 0) return null

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell width="8%">Id</TableCell>
            <TableCell>Nome</TableCell>
            <TableCell>E-mail</TableCell>
            <TableCell>Departamento</TableCell>
            <TableCell align="right">
              {totalParticipants} participante
              {totalParticipants !== 1 ? 's' : ''}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {platformRows.map((row) => (
            <TableRow key={`platform-${row.departmentId}-${row.userId}`}>
              <TableCell>{row.userId}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.email || '—'}</TableCell>
              <TableCell>{row.department}</TableCell>
              <TableCell align="right">
                {!disabled && (
                  <IconButton
                    size="small"
                    onClick={() =>
                      onRemovePlatformUser(row.userId, row.departmentId)
                    }
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
          {externalRecipients.map((recipient) => (
            <TableRow key={`external-${recipient.email}`}>
              <TableCell>{'—'}</TableCell>
              <TableCell>{recipient.name}</TableCell>
              <TableCell>{recipient.email}</TableCell>
              <TableCell>{recipient.department?.name || '—'}</TableCell>
              <TableCell align="right">
                {!disabled && (
                  <IconButton
                    size="small"
                    onClick={() => onRemoveExternal(recipient.email)}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default ParticipantsTable
